import { render } from "./TechnoStack.vue?vue&type=template&id=273a4135&scoped=true"
import script from "./TechnoStack.vue?vue&type=script&lang=js"
export * from "./TechnoStack.vue?vue&type=script&lang=js"

import "./TechnoStack.vue?vue&type=style&index=0&id=273a4135&lang=scss&scoped=true"

import exportComponent from "/var/www/recruitment-form-front-end-master/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-273a4135"]])

export default __exports__